<template>
	<div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="semester_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox :validate-error="errors[0]" v-model="formData.semester_id"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="program_code" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('program')">
                            <program-selectbox
                                :disabled="true"
                                v-model="formData.program_code"
                                :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="exam" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('exam')">
                            <parameter-selectbox
                                :validate-error="errors[0]"
                                code="cartoon_animation_application_exam_types"
                                v-model="formData.exam"
                            ></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="rate" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('rate')">
                            <b-form-input
                                type="number"
                                min="0"
                                max="100"
                                step="5"
                                v-check-min-max-value
                                v-model="formData.rate"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="updateForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
	</div>
</template>

<script>
// Components
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox.vue";
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox";
// Services
import CartoonAnimationService from "@/services/CartoonAnimationService"
// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"
export default {
    components: {
        ValidationProvider,
        ValidationObserver,

        ParameterSelectbox,
        ProgramSelectbox,
        SemestersSelectbox,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                semester_id:null,
                program_code:null,
                exam:null,
                rate:null,
            },
            formLoading: false,
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            CartoonAnimationService.getExamType(id)
                         .then(response => {
                             let data = response.data.data;
                             this.formData = {
                                 semester_id:data.semester_id,
                                 program_code:data.program_code,
                                 exam:data.exam,
                                 rate:data.rate,
                             }
                         })
                         .catch(e => {
                             this.showErrors(e)
                         })
        },

        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                this.formLoading = true;
                CartoonAnimationService.updateExamType(this.formId, this.formData)
                             .then(response => {
                                 this.$emit('updateFormSuccess', true);
                                 this.$toast.success(this.$t('api.' + response.data.message));
                             })
                             .catch(e => {
                                 this.showErrors(e, this.$refs.formModalValidate);
                             })
                             .finally(() => {
                                 this.formLoading = false
                             })
            }
        }
    }
}
</script>
